module.exports = __webpack_public_path__ + "static/media/orderbook.19864e5a.png";